import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>HeroPixelLab - Premium Online Dataspill</title>
        <meta name="description" content="HeroPixelLab - premium nettbutikk for online dataspill. Oppdag eksklusive spill, digitale nøkler og unike samleobjekter." />
        <link href="https://heropixellab.com/privacy-policy/" rel="canonical"/>
        
      </Helmet>

      <div className="privacy-policy">
      <h1>Personvernerklæring</h1>
      <p className="last-updated">Sist oppdatert: 1. januar 2025</p>

      <section>
        <h2>1. Innledning</h2>
        <p>
          Velkommen til HeroPixelLab sin personvernerklæring. Denne erklæringen forklarer hvordan vi samler inn, bruker, lagrer og beskytter dine personopplysninger når du bruker våre nettsider og tjenester. Vi er opptatt av å beskytte ditt personvern og behandle dine opplysninger i samsvar med gjeldende personvernlovgivning, inkludert EUs personvernforordning (GDPR).
        </p>
      </section>

      <section>
        <h2>2. Behandlingsansvarlig</h2>
        <p>
          HeroPixelLab er behandlingsansvarlig for behandlingen av personopplysninger som beskrevet i denne erklæringen. 
          Kontaktinformasjon: 
          E-post: heropixellab@hotmail.com
          Adresse: HeroPixelLab AS, Kirkegata 15, 4611 Kristiansand, Norge
        </p>
      </section>

      <section>
        <h2>3. Hvilke opplysninger vi samler inn</h2>
        <h3>3.1 Opplysninger du gir oss</h3>
        <ul>
          <li>Navn og kontaktinformasjon (navn, e-postadresse, telefonnummer)</li>
          <li>Leverings- og faktureringsadresse</li>
          <li>Betalingsinformasjon (behandles av vår betalingsleverandør)</li>
          <li>Bestillingshistorikk og kjøpsinformasjon</li>
          <li>Kundeservice-korrespondanse</li>
          <li>Kontooplysninger (brukernavn, passord, profilinformasjon)</li>
        </ul>

        <h3>3.2 Opplysninger vi samler automatisk</h3>
        <ul>
          <li>IP-adresse og enhetsinformasjon</li>
          <li>Nettlesertype og versjon</li>
          <li>Bruksmønster på nettsiden</li>
          <li>Informasjonskapsler (cookies) og lignende teknologier</li>
          <li>Sidevisninger og interaksjoner</li>
        </ul>
      </section>

      <section>
        <h2>4. Formål med behandlingen</h2>
        <p>Vi behandler dine personopplysninger for følgende formål:</p>
        <ul>
          <li>Behandle og levere dine bestillinger</li>
          <li>Administrere din brukerkonto</li>
          <li>Håndtere kundeservice og brukerstøtte</li>
          <li>Sende ordrebekreftelser og leveringsstatus</li>
          <li>Oppfylle juridiske og regulatoriske forpliktelser</li>
          <li>Forbedre våre produkter og tjenester</li>
          <li>Markedsføring (kun med ditt samtykke)</li>
          <li>Forhindre svindel og sikre betalingstransaksjoner</li>
        </ul>
      </section>

      <section>
        <h2>5. Rettslig grunnlag for behandlingen</h2>
        <p>
          Vår behandling av dine personopplysninger er basert på følgende rettslige grunnlag i henhold til GDPR:
        </p>
        <ul>
          <li><strong>Gjennomføring av avtale</strong> (GDPR art. 6(1)(b)) – behandling nødvendig for å oppfylle kjøpsavtalen</li>
          <li><strong>Samtykke</strong> (GDPR art. 6(1)(a)) – for markedsføring og frivillig delte opplysninger</li>
          <li><strong>Rettslig forpliktelse</strong> (GDPR art. 6(1)(c)) – oppfyllelse av lovkrav</li>
          <li><strong>Berettiget interesse</strong> (GDPR art. 6(1)(f)) – sikkerhet, svindelbekjempelse og tjenesteforbedring</li>
        </ul>
      </section>

      <section>
        <h2>6. Informasjonskapsler (cookies)</h2>
        <p>
          Vi bruker informasjonskapsler for å forbedre din brukeropplevelse. Dette inkluderer:
        </p>
        <ul>
          <li>Nødvendige informasjonskapsler for nettstedets funksjonalitet</li>
          <li>Preferanseinformasjonskapsler for innstillinger og valg</li>
          <li>Analytiske informasjonskapsler for å forstå bruksmønstre</li>
          <li>Markedsføringsinformasjonskapsler (kun med samtykke)</li>
        </ul>
        <p>
          Du kan når som helst administrere eller deaktivere informasjonskapsler i nettleserinnstillingene. Vær oppmerksom på at noen funksjoner kan bli utilgjengelige hvis du blokkerer informasjonskapsler.
        </p>
      </section>

      <section>
        <h2>7. Deling og overføring av opplysninger</h2>
        <p>
          Vi deler dine personopplysninger med følgende kategorier av mottakere:
        </p>
        <ul>
          <li><strong>Betalingsleverandører</strong> – for å behandle betalinger</li>
          <li><strong>Leverandører av digitale produkter</strong> – for å levere spillnøkler og digitale varer</li>
          <li><strong>IT-leverandører</strong> – for hosting og teknisk drift</li>
          <li><strong>Logistikkpartnere</strong> – for levering av fysiske produkter (hvis aktuelt)</li>
          <li><strong>Offentlige myndigheter</strong> – når påkrevd i henhold til lov</li>
        </ul>
        <p>
          Vi overfører ikke dine opplysninger til tredjeland uten tilstrekkelig beskyttelsesnivå, med mindre det foreligger gyldig overføringsgrunnlag etter GDPR kapittel V.
        </p>
      </section>

      <section>
        <h2>8. Lagringstid</h2>
        <p>
          Vi lagrer dine personopplysninger kun så lenge det er nødvendig for formålene de ble samlet inn for:
        </p>
        <ul>
          <li>Brukerkonto: Så lenge kontoen er aktiv</li>
          <li>Kjøpsinformasjon: 5 år i henhold til bokføringsloven</li>
          <li>Markedsføringssamtykke: Inntil du trekker samtykket tilbake</li>
          <li>Kundeservicekorrespondanse: 2 år etter siste kontakt</li>
          <li>Betalingsinformasjon: Behandles av betalingsleverandør</li>
        </ul>
      </section>

      <section>
        <h2>9. Dine rettigheter</h2>
        <p>
          Som registrert bruker har du følgende rettigheter:
        </p>
        <ul>
          <li><strong>Rett til innsyn</strong> – be om kopi av dine registrerte personopplysninger</li>
          <li><strong>Rett til retting</strong> – få uriktige opplysninger korrigert</li>
          <li><strong>Rett til sletting</strong> – be om sletting av dine opplysninger</li>
          <li><strong>Rett til begrensning</strong> – begrense behandlingen av dine opplysninger</li>
          <li><strong>Rett til dataportabilitet</strong> – få utlevert dine data i maskinlesbart format</li>
          <li><strong>Rett til å protestere</strong> – protestere mot bestemt behandling</li>
          <li><strong>Trekke tilbake samtykke</strong> – når som helst trekke tilbake gitt samtykke</li>
        </ul>
        <p>
          For å utøve dine rettigheter, kontakt oss på heropixellab@hotmail.com. Vi vil svare innen 30 dager.
        </p>
      </section>

      <section>
        <h2>10. Sikkerhet</h2>
        <p>
          Vi bruker passende tekniske og organisatoriske sikkerhetstiltak for å beskytte dine personopplysninger, inkludert:
        </p>
        <ul>
          <li>SSL/TLS-kryptering av all dataoverføring</li>
          <li>Sterk autentisering og tilgangskontroll</li>
          <li>Regelmessig sikkerhetstesting og sårbarhetsskanning</li>
          <li>Minimering og pseudonymisering av personopplysninger</li>
          <li>Lagring av passord med hashing og salting</li>
          <li>Overvåking og logging av tilgang</li>
        </ul>
      </section>

      <section>
        <h2>11. Profilering og automatisert beslutningstaking</h2>
        <p>
          Vi benytter ikke automatisert beslutningstaking som har juridisk eller tilsvarende betydning for deg. Eventuell profilering for markedsføringsformål utføres kun med ditt uttrykkelige samtykke.
        </p>
      </section>

      <section>
        <h2>12. Klage</h2>
        <p>
          Hvis du mener at vår behandling av dine personopplysninger ikke er i samsvar med regelverket, kan du klage til Datatilsynet. 
          Kontaktinformasjon til Datatilsynet:
          E-post: heropixellab@hotmail.com
          Telefon: +47 22 39 69 00
        </p>
      </section>

      <section>
        <h2>13. Endringer i personvernerklæringen</h2>
        <p>
          Vi forbeholder oss retten til å oppdatere denne personvernerklæringen. Ved vesentlige endringer vil vi varsle deg via e-post eller ved fremtredende melding på nettsiden. Vi anbefaler at du jevnlig gjennomgår denne erklæringen for å holde deg oppdatert.
        </p>
      </section>

      <section>
        <h2>14. Kontakt oss</h2>
        <p>
          Har du spørsmål om denne personvernerklæringen eller vår behandling av dine personopplysninger, vennligst kontakt oss:
        </p>
        <ul>
          <li>E-post: heropixellab@hotmail.com</li>
          <li>Telefon: +4738172040</li>
          <li>Brev: HeroPixelLab AS, Kirkegata 15, 4611 Kristiansand, Norge</li>
        </ul>
      </section>

      <p className="policy-footer">© 2025 HeroPixelLab. Alle rettigheter forbeholdt.</p>
    </div>
  
    </>);
};

export default PrivacyPolicy;